// Vendors
import { useState } from 'react';
// Enumerations
import { ModalReferencesEnumeration } from 'enumerations/modal-references.enumeration';
// Event Handlers
import { CancelDropModalFooterHandlers } from '../handlers/cancel-drop-modal-footer.handlers';
import { CancelDropModalFooterTrackingHandlers } from '../handlers/cancel-drop-modal-footer.tracking.handlers';
import { LogHandlers } from 'handlers/log.handlers';
// Hooks
import { useCallbackBackHook } from 'hooks/callback-back.hook';
import { useAppTrackingHook } from 'tracking/app-tracking.hook';
// Types
import { CancelDropModalModalFooterHookType } from './types/cancel-drop-modal-modal-footer.hook.type';

const useCancelDropModalHook = (
  id: ModalReferencesEnumeration = ModalReferencesEnumeration.CANCEL_PROCESS
): CancelDropModalModalFooterHookType => {
  const [loading, setLoading] = useState<boolean>(false);

  const { handleSendCustomActionEvent } = LogHandlers(),
    { handleLogCallbackUrlCallEvent } = useCallbackBackHook(),
    { handleConfirmCancelApplicationClickTracking, handleConfirmDropApplicationClickTracking } =
      useAppTrackingHook(CancelDropModalFooterTrackingHandlers);

  return {
    ...CancelDropModalFooterHandlers({
      handleConfirmCancelApplicationClickTracking,
      handleConfirmDropApplicationClickTracking,
      handleSendCustomActionEvent,
      handleLogCallbackUrlCallEvent,
      id,
      setLoading,
    }),
    loading,
  };
};

export { useCancelDropModalHook };
